import type { TextToWinSettings } from '../types/TextToWinSettings';

export const createDefaultTextToWinSettings = (): TextToWinSettings => ({
  dateStart: '',
  dateEnd: '',
  dateDraw: '',
  dateResultsSend: '',
  entryIntervalMinutes: null,
  maxEntriesPerInterval: null,
  maxEntriesPerContact: null,
  winnersCount: null,
  entrySuccessMessageText: '',
  entryIntervalLimitMessageText: '',
  entryTotalLimitMessageText: '',
  entryNotStartedMessageText: '',
  entryEndedMessageText: '',
  winnerMessageText: '',
  nonWinnerMessageText: '',
});

export const normalizeTextToWinSettings = (
  settings?: Partial<TextToWinSettings> | null,
): TextToWinSettings => {
  const defaults = createDefaultTextToWinSettings();

  return {
    dateStart: settings?.dateStart || defaults.dateStart,
    dateEnd: settings?.dateEnd || defaults.dateEnd,
    dateDraw: settings?.dateDraw || defaults.dateDraw,
    dateResultsSend: settings?.dateResultsSend || defaults.dateResultsSend,
    entryIntervalMinutes: settings?.entryIntervalMinutes ?? null,
    maxEntriesPerInterval: settings?.maxEntriesPerInterval ?? null,
    maxEntriesPerContact: settings?.maxEntriesPerContact ?? null,
    winnersCount: settings?.winnersCount ?? null,
    entrySuccessMessageText: settings?.entrySuccessMessageText ?? '',
    entryIntervalLimitMessageText: settings?.entryIntervalLimitMessageText ?? '',
    entryTotalLimitMessageText: settings?.entryTotalLimitMessageText ?? '',
    entryNotStartedMessageText: settings?.entryNotStartedMessageText ?? '',
    entryEndedMessageText: settings?.entryEndedMessageText ?? '',
    winnerMessageText: settings?.winnerMessageText ?? '',
    nonWinnerMessageText: settings?.nonWinnerMessageText ?? '',
  };
};
